import { createFileRoute } from "@tanstack/react-router";

import { OrgMembersContainer } from "@/features/organisation/containers/org-members-container";

export const Route = createFileRoute("/organisation/members")({
  component: OrgMembersContainer,
});
